import { useEffect, useState } from 'react'

export function useBTC() {
    const [price, setPrice] = useState(0)
    const fetchBTCValue = async () => {
        const response = await fetch('https://blockchain.info/ticker')
        const result = await response.json()
        if (result) {
            setPrice(result.USD.sell)
        } else {
            setPrice(0)
        }
    }
    useEffect(() => {
        fetchBTCValue()
    }, [])

    return price
}
